<template>
  <div
    class="faq-card"
    :class="{ 'border-primary-2': isExpanded }"
    @click="toggleExpandHandle"
  >
    <div class="card-body">
      <h3
        class="font-extrabold text-[18px] text-mobile-heading-4 md:text-heading-4 text-primary-1 max-md:w-[240px]"
        :class="{ 'text-primary-2': isExpanded }"
      >
        {{ question }}
      </h3>
      <button
        v-if="iconType == 'chevron'"
        class="expand-btn border rounded-full w-[34px] h-[34px]"
        aria-label="faq chevron"
        :class="{ '!text-primary-2': isExpanded }"
      >
        <IconChevron
          class="icon text-[20px]"
          :class="{ '!-rotate-90 text-primary-2': isExpanded }"
        />
      </button>
      <button
        v-else
        class="expand-btn border-2 rounded-full w-[20px] h-[20px]"
        :class="{ '!text-primary-2': isExpanded }"
      >
        <IconPlus v-if="!isExpanded" class="text-[9px] !mb-0" />
        <IconMinus v-else class="text-[9px] !mb-0" />
      </button>
      <slot />
    </div>
    <transition name="collapse">
      <div v-if="isExpanded" class="text-gray-1">
        <div class="mt-[30px] text-mobile-paragraph-1 md:text-paragraph-1">
          {{ answer }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
defineProps({
  question: {
    type: String,
    required: true,
  },
  answer: {
    type: String,
    required: true,
  },
  iconType: {
    type: String,
    default: "chevron",
  },
});
const isExpanded = ref(false);
function toggleExpandHandle() {
  isExpanded.value = !isExpanded.value;
}
</script>
